export enum Sidebar {
  Bottom = 'Bottom',
  Right = 'Right',
  Top = 'Top'
}
